/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./icon-pure-language.vue?vue&type=template&id=3fb9b19e&scoped=true&"
import script from "./icon-pure-language.vue?vue&type=script&lang=ts&"
export * from "./icon-pure-language.vue?vue&type=script&lang=ts&"
import style0 from "./icon-pure-language.vue?vue&type=style&index=0&id=3fb9b19e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb9b19e",
  null
  
)

export default component.exports